import React from 'react';
import './css/Kick.css';
import img from './img/yeezy350v2.jpg';

const Kick = (props) => {

  const items = props.info.map((item,key) =>
    <li key={key}>
      <a href={item.link} target="blank">{item.text}</a>
    </li>
  );

  return (
    <div className="col"> 
      <section className="body-text text-center">{props.name} - {props.colorway}</section>
      <section className="body-text text-center">{props.date}</section>
      <section className="body-text text-center">{props.price}</section>
      <section className="body-text text-center"><img className="img-fluid max-size" src={img} alt={props.name}/></section>
      <section className="text-center mt-2">
       <strong className="body-text">Raffle Links:</strong> 
       <ul className="list-group list-inline">
         {items}
       </ul>
      </section>
    </div>
  )
}

export default Kick;
